import React from 'react';

import { TGenerateReactNodeMessage } from './types';

export const generateReactNodeMessage: TGenerateReactNodeMessage = arr => {
  return arr.map(line => <p>- {line} </p>)
};
